import IMask from 'imask'
import { FormValidator } from './form-validator'
import { createLabelHandler } from './labels'
export class SeaForm {
  /**
   *
   * @param {HTMLFormElement} form
   */
  constructor(form) {
    this.form = form
    this.elements = Array.from(this.form.elements)
    this.validator = new FormValidator(this.form)
    this.masks = []
    createLabelHandler(this.elements)

    this.elements.forEach((control) => {
      if (control.type === 'tel') {
        IMask(control, {
          mask: '000 000-0000'
        })
      }
      else if (control.id === 'bdate') {
        IMask(control, {
          mask: '00-00'
        })
      }
    })
  }
}
